document.addEventListener("DOMContentLoaded", function() {
    var video = document.querySelector('#shopify-section-template--17828899815614__daf5b1fb-5177-43c1-a14f-2ce4e6a08101 .banner_video');
    var vidButton = document.querySelector('.cstm_mute_vid');
    
    // Debugging: Check if the video and button are correctly selected
    if (video) {
        console.log("Video element found:", video);
    } else {
        console.log("Video element not found.");
    }

    if (vidButton) {
        console.log("Mute button found:", vidButton);
    } else {
        console.log("Mute button not found.");
    }

    if (video && vidButton) {
        // Ensure video is muted by default
        video.muted = true;
        console.log("Video muted by default.");

     vidButton.addEventListener('click', function() {
    // Toggle the muted state
    video.muted = !video.muted;
    console.log("Muted state changed:", video.muted);

    // Update button text or SVG based on mute state
    if (video.muted) {
              vidButton.innerHTML = '<svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.1657 2.14424C12.8728 2.50021 13 3.27314 13 3.7446V20.2561C13 20.7286 12.8717 21.4998 12.1656 21.8554C11.416 22.2331 10.7175 21.8081 10.3623 21.4891L4.95001 16.6248H3.00001C1.89544 16.6248 1.00001 15.7293 1.00001 14.6248L1 9.43717C1 8.3326 1.89543 7.43717 3 7.43717H4.94661L10.3623 2.51158C10.7163 2.19354 11.4151 1.76635 12.1657 2.14424ZM11 4.63507L6.00618 9.17696C5.82209 9.34439 5.58219 9.43717 5.33334 9.43717H3L3.00001 14.6248H5.33334C5.58015 14.6248 5.81823 14.716 6.00179 14.881L11 19.3731V4.63507Z" fill="#000000"/><path d="M16.0368 4.73124C16.1852 4.19927 16.7368 3.88837 17.2688 4.03681C20.6116 4.9696 23 8.22106 23 12C23 15.779 20.6116 19.0304 17.2688 19.9632C16.7368 20.1117 16.1852 19.8007 16.0368 19.2688C15.8884 18.7368 16.1993 18.1852 16.7312 18.0368C19.1391 17.3649 21 14.9567 21 12C21 9.04332 19.1391 6.63512 16.7312 5.96321C16.1993 5.81477 15.8884 5.2632 16.0368 4.73124Z" fill="#000000"/><path d="M16.2865 8.04192C15.7573 7.88372 15.2001 8.18443 15.0419 8.71357C14.8837 9.24271 15.1844 9.79992 15.7136 9.95812C16.3702 10.1544 17 10.9209 17 12C17 13.0791 16.3702 13.8456 15.7136 14.0419C15.1844 14.2001 14.8837 14.7573 15.0419 15.2865C15.2001 15.8156 15.7573 16.1163 16.2865 15.9581C17.9301 15.4667 19 13.8076 19 12C19 10.1924 17.9301 8.53333 16.2865 8.04192Z" fill="#000000"/></svg>';
    } else {
  vidButton.innerHTML = '<svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 9L22 15M22 9L16 15M13 3L7 8H5C3.89543 8 3 8.89543 3 10V14C3 15.1046 3.89543 16 5 16H7L13 21V3Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    } 
});

    }
});


document.addEventListener("DOMContentLoaded", function() {
    // Select all swatches and the active one
    const swatches = document.querySelectorAll('.cstm_swatch_pro');
    const activeSwatch = document.querySelector('.cstm_swatch_pro.active');
    
    // Select the elements that will be updated
    const productTitle = document.querySelector('.product-page--heading');
    const productPrice = document.querySelector('.product-price--wrapper .product-price--original');
    const productImage = document.querySelector('.product-media--featured .image--root img');

    // Function to update the product details
    function updateProductDetails(title, price, imgSrc) {
        productTitle.textContent = title;
        productPrice.textContent = price;
        productImage.setAttribute('data-srcset', imgSrc);
        productImage.setAttribute('srcset', imgSrc);
        productImage.setAttribute('src', imgSrc);
    }

    // Add event listeners to each swatch
    swatches.forEach(swatch => {
        swatch.addEventListener('mouseenter', function() {
            const title = swatch.getAttribute('data-title');
            const price = swatch.getAttribute('data-price');
            const imgSrc = swatch.getAttribute('data-img');
          setTimeout(function() {
            updateProductDetails(title, price, imgSrc);
          }, 500);
        });

        swatch.addEventListener('mouseleave', function() {
            // Reset to active swatch when leaving
            const activeTitle = activeSwatch.getAttribute('data-title');
            const activePrice = activeSwatch.getAttribute('data-price');
            const activeImgSrc = activeSwatch.getAttribute('data-img');
            setTimeout(function() {
              updateProductDetails(activeTitle, activePrice, activeImgSrc);
            }, 500);
        });
    });
});

$(document).ready(function () {
  // ---------- NEXT ARROW ----------
  $(".next_arrow").click(function () {
    var $current = $('.product-media--thumb[data-active="true"]').parent();
    var $next = $current.next();

    if ($next.length) {
      $next.find(".product-media--thumb").click();
    } else {
      $(".product-media--thumb").first().click();
    }
  });

  // ---------- PREVIOUS ARROW ----------
  $(".left_arrow").click(function () {
    var $current = $('.product-media--thumb[data-active="true"]').parent();
    var $prev = $current.prev();

    if ($prev.length) {
      $prev.find(".product-media--thumb").click();
    } else {
      $(".product-media--thumb").last().click();
    }
  });

  // ---------- SWIPE FUNCTIONALITY (MOBILE) ----------
  const targetDiv = $(".product-media--wrapper");

  let startX = 0,
    startY = 0,
    distX = 0,
    distY = 0,
    startTime = 0;

  const threshold = 50; // Minimum distance for swipe
  const restraint = 100; // Allow more vertical tolerance
  const allowedTime = 600; // Max time allowed

  targetDiv.on("touchstart", function (e) {
    const touch = e.originalEvent.touches[0];
    startX = touch.pageX;
    startY = touch.pageY;
    startTime = new Date().getTime();
  });

  targetDiv.on("touchend", function (e) {
    const touch = e.originalEvent.changedTouches[0];
    distX = touch.pageX - startX;
    distY = touch.pageY - startY;
    const elapsedTime = new Date().getTime() - startTime;

    if (elapsedTime <= allowedTime) {
      if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint) {
        if (distX > 0) {
          // Swipe Right
          $(".left_arrow").trigger("click");
        } else {
          // Swipe Left
          $(".next_arrow").trigger("click");
        }
      }
    }
  });
});


// $(document).ready(function() {

//   $('.next_arrow').click(function() {
//       var $current = $('.product-media--thumb[data-active="true"]').parent();
//       var $next = $current.next();
      
//       if ($next.length) {
//           $next.find('.product-media--thumb').click();
//       } else {
//           // If no next element, click the first thumbnail
//           $('.product-media--thumb').first().click();
//       }
//   });
  
//   $('.left_arrow').click(function() {
//       var $current = $('.product-media--thumb[data-active="true"]').parent();
//       var $prev = $current.prev();
      
//       if ($prev.length) {
//           $prev.find('.product-media--thumb').click();
//       } else {
//           // If no previous element, click the last thumbnail
//           $('.product-media--thumb').last().click();
//       }
//   });

//   const targetDiv = $('.product-media--wrapper'); // Replace with your div's ID or class

//   let startX = 0;
//   let startY = 0;
//   let distX = 0;
//   let distY = 0;
//   const threshold = 50; // Minimum distance for a swipe
//   const restraint = 30; // Maximum distance in the Y-axis allowed for a swipe
//   const allowedTime = 500; // Maximum time allowed to consider it a swipe
//   let startTime;

//   // Handle the start of the touch
//   targetDiv.on('touchstart', function(e) {
//       const touch = e.originalEvent.touches[0];
//       startX = touch.pageX;
//       startY = touch.pageY;
//       startTime = new Date().getTime(); // Record the start time
//       e.preventDefault();
//   });

//   // Handle the end of the touch
//   targetDiv.on('touchend', function(e) {
//       const touch = e.originalEvent.changedTouches[0];
//       distX = touch.pageX - startX; // Calculate the distance moved on X axis
//       distY = touch.pageY - startY; // Calculate the distance moved on Y axis
//       const elapsedTime = new Date().getTime() - startTime; // Calculate the elapsed time
      
//       // Check if it's a valid horizontal swipe
//       if (elapsedTime <= allowedTime) {
//           if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint) {
//               if (distX > 0) {
//                   // Swipe right
//                   console.log("Swiped right");
//                   $('.left_arrow').click();
//               } else {
//                   // Swipe left
//                   console.log("Swiped left");
//                   $('.next_arrow').click();
//               }
//           }
//       }
//       e.preventDefault();
//   });


  
// });





